<script setup>
const props = defineProps({
  image: {
    type: String,
    required: true,
  },
  heading: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
  error: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div
    class="flex justify-center flex-col-reverse items-center py-12 sm:py-5 sm:flex-row min-h-full h-full bg-gray-50 px-5 lg:px-0">
    <div class="sm:py-32 sm:whitespace-nowrap px-6">
      <p class="text-base font-semibold leading-8 text-indigo-600">{{ __('Error :code', { code: error }) }}</p>
      <h1 class="font-bold text-3xl tracking-tight text-gray-900 sm:text-4xl md:text-5xl">
        {{ heading }}</h1>
      <p class="mt-6 text-base leading-7 whitespace-normal max-w-2xl text-gray-600">
        {{ message }}</p>
      <div class="mt-10">
        <a :href="route('index')" class="text-sm font-semibold leading-7 text-indigo-600"><span
          aria-hidden="true">&larr;</span>
          {{ __('Back to home') }}</a>
      </div>
    </div>
    <div class="flex justify-center w-full h-full max-w-sm lg:max-w-lg">
      <img :src="image" :alt="'Error' + error + ' Image'"
           class="size-60  sm:w-full h-full object-cover object-center rounded-full lg:rounded-none" />
    </div>
  </div>
</template>
